import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth/auth.service";

export const permissionGuard: CanActivateFn = (route) => {
	const authService = inject(AuthService);
	const permissions = authService.getUserPermissions();
	const router = inject(Router);

	if (route.data["permission"] === "PAYMENT_VIEW" && !permissions?.includes(route.data["permission"])) {
		router.navigate(["/profile"]);
		return false;
	}

	return !!permissions?.includes(route.data["permission"]);
};
